import { colors } from '../../colors';
var pagination = {
  activeColor: colors.pinkishRed,
  defaultColor: colors.black
};
export default pagination;